import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "./api";
import { useAuth } from "./auth";

const Ctx = createContext(null);

export function MarketProvider({ children }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [meta, setMeta] = useState({ categories: [], cities: [], demo_mode: true });
  const [savedIds, setSavedIds] = useState([]);
  const [compare, setCompare] = useState(() => JSON.parse(localStorage.getItem("vs_compare") || "[]"));

  useEffect(() => { api.get("/public/meta").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (user) {
      api.get("/saved-ids").then((r) => setSavedIds(r.data)).catch(() => {});
      if (user.compare?.length && !compare.length) setCompare(user.compare);
    } else setSavedIds([]);
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { localStorage.setItem("vs_compare", JSON.stringify(compare)); if (user) api.put("/me/compare", { ids: compare }).catch(() => {}); }, [compare, user]);

  const toggleSave = useCallback(async (l) => {
    if (!user) { toast("Log in to save businesses"); nav("/login"); return; }
    const on = savedIds.includes(l.id);
    try {
      if (on) await api.delete(`/saved/${l.id}`); else await api.post(`/saved/${l.id}`);
      setSavedIds((s) => (on ? s.filter((x) => x !== l.id) : [...s, l.id]));
      toast.success(on ? "Removed from saved" : "Saved to your list");
    } catch (e) { toast.error(errMsg(e)); }
  }, [user, savedIds, nav]);

  const toggleCompare = useCallback((l) => {
    if (compare.includes(l.id)) { setCompare(compare.filter((x) => x !== l.id)); return; }
    if (compare.length >= 3) { toast.error("You can compare up to three businesses"); return; }
    toast.success("Added to compare");
    setCompare([...compare, l.id]);
  }, [compare]);

  const catName = (slug) => meta.categories.find((c) => c.slug === slug)?.name || slug;
  return <Ctx.Provider value={{ meta, savedIds, toggleSave, compare, setCompare, toggleCompare, catName }}>{children}</Ctx.Provider>;
}
export const useMarket = () => useContext(Ctx);
